import { Routes } from '@angular/router';
//import { tokenGuard } from './guards'; // MÓDULO TEMPORAL MAYO 2025
import { RoutesUrl } from '@app/routes.enum';
import { authGuard } from '@app/guards/auth.guard';
import { RoleGuard } from '@app/guards/role.guard';
import { PermissionGuard } from '@app/guards/permission.guard';
import { tipoRolGuard } from '@app/guards/tipo-rol.guard';
import { subdominioPortalGuard } from '@app/guards/subdominio-portal.guard';
import { sinSesionGuard } from '@app/guards/sin-sesion.guard';
import { MainComponent } from '@app/pages/main/main.component';

export const routes: Routes = [

  // --- RUTA PÚBLICA: LOGIN ---
  // Rutas externas sin el layout principal. sinSesionGuard detecta si ya hay
  // sesión activa (local o vía cookie compartida entre subdominios) y redirige
  // a /main/torneos en vez de mostrar el formulario de login de nuevo.
  {
    path: 'login',
    canActivate: [sinSesionGuard],
    loadChildren: () =>
      import('./pages/login/login.routes').then((r) => r.LoginRoutes),
    data: { noindex: true }
  },
  {
    path: 'portal', // La URL base será /portal
    // canActivateChild (no canActivate): el guard necesita el `data` de cada ruta hija
    // (ej. permiteSubdominioEquipo), que no está disponible en el snapshot del padre.
    canActivateChild: [subdominioPortalGuard],
    loadChildren: () =>
      import('./pages/portal/portal.routes').then((r) => r.PortalRoutes),
  },

  // --- RUTAS PRIVADAS: DENTRO DEL LAYOUT PRINCIPAL ---
  // Esta ruta carga el MainComponent, que contiene las barras de navegación.
  // Está protegida por el authGuard.
  {
    path: 'main', // Usaremos '/main' como la ruta base para todo el contenido privado.
    component: MainComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: RoutesUrl.DASHBOARD,
        pathMatch: 'full',
      },
      {
        path: RoutesUrl.LOGIN,
        loadChildren: () =>
          import('./pages/login/login.routes').then((r) => r.LoginRoutes),
      },
      {
        path: RoutesUrl.DASHBOARD,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/dashboard/dashboard.routes').then(
            (r) => r.DashboardRoutes
          ),
      },
      {
        path: RoutesUrl.REPORTES,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/reportes/reportes.routes').then(
            (r) => r.ReportesRoutes
          ),
      },
      {
        path: RoutesUrl.EQUIPOS,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/equipos/equipos.routes').then(
            (r) => r.EquiposRoutes
          ),
      },
      {
        path: RoutesUrl.LIGAS,
        canActivate: [authGuard, tipoRolGuard('GLOBAL')],
        loadChildren: () =>
          import('./pages/ligas/ligas.routes').then(
            (r) => r.LigasRoutes
          ),
      },
      {
        path: RoutesUrl.NOTICIA_TAGS_GLOBALES,
        canActivate: [authGuard, tipoRolGuard('GLOBAL')],
        loadChildren: () =>
          import('./pages/noticias-tags-globales/noticias-tags-globales.routes').then(
            (r) => r.NoticiasTagsGlobalesRoutes
          ),
      },
      {
        path: RoutesUrl.SEDES,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-sedes-liga' },
        loadChildren: () =>
          import('./pages/sedes/sedes.routes').then(
            (r) => r.SedesRoutes
          ),
      },
      {
        path: RoutesUrl.ARBITROS,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-arbitros' },
        loadChildren: () =>
          import('./pages/arbitros/arbitros.routes').then(
            (r) => r.ArbitrosRoutes
          ),
      },
      {
        path: RoutesUrl.ENLACES_CORTOS,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-enlaces-cortos' },
        loadChildren: () =>
          import('./pages/enlaces-cortos/enlaces-cortos.routes').then(
            (r) => r.EnlacesCortosRoutes
          ),
      },
      {
        path: RoutesUrl.JUGADORES,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/jugadores/jugadores-global/jugadores-global.routes').then(
            (r) => r.JugadoresGlobalRoutes
          ),
      },


      {
        path: RoutesUrl.MIEQUIPO,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/equipos/mi-equipo/mi-equipo.routes').then(
            (r) => r.MiEquipoRoutes
          ),
      },
      {
        path: RoutesUrl.MISJUGADORES,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/jugadores/mis-jugadores/mis-jugadores.routes').then(
            (r) => r.MisJugadoresRoutes
          ),
      },
      {
        path: RoutesUrl.FAMILIAS,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/jugadores/familias/familias.routes').then(
            (r) => r.FamiliasRoutes
          ),
      },
      {
        path: RoutesUrl.USUARIOS_ADMIN,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: ['gestionar-usuarios', 'gestionar-usuarios-equipo'] },
        loadChildren: () =>
          import('./pages/usuarios-admin/usuarios-admin.routes').then(
            (r) => r.UsuariosAdminRoutes
          ),
      },
      {
        path: RoutesUrl.ROLES_EQUIPO,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: ['gestionar-usuarios-equipo'] },
        loadChildren: () =>
          import('./pages/roles-equipo/roles-equipo.routes').then(
            (r) => r.RolesEquipoRoutes
          ),
      },
      {
        path: RoutesUrl.CATEGORIAS_DIVISIONES,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: ['gestionar-categorias', 'gestionar-divisiones'] },
        loadChildren: () =>
          import('./pages/categorias-divisiones/categorias-divisiones.routes').then(
            (r) => r.CategoriasDivisionesRoutes
          ),
      },
      {
        path: RoutesUrl.FINEQ,
        canActivate: [authGuard, PermissionGuard],
        data: { permiso: 'gestionar-financiero-equipo' },
        loadChildren: () =>
          import('./pages/financiero-equipo/financiero-equipo.routes').then(
            (r) => r.FinancieroEquipoRoutes
          ),
      },
      {
        path: RoutesUrl.FINLI,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/financiero-liga/financiero-liga.routes').then(
            (r) => r.FinancieroLigaRoutes
          ),
      },
      {
        path: RoutesUrl.DOCS,
        canActivate: [authGuard, RoleGuard],
        // Ruta compartida GLOBAL (catálogo de liga) y EQUIPO (catálogo del equipo),
        // por eso se valida por rol y no por permiso equipo-específico.
        data: { rol: ['ROOT', 'ADMIN', 'PROPIETARIO', 'ROOT_EQUIPO', 'ADMINISTRADOR'] },
        loadChildren: () =>
          import('./pages/documentos/documentos.routes').then(
            (r) => r.DocumentosRoutes
          ),
      },
      {
        path: RoutesUrl.NOTICIAS,
        canActivate: [authGuard, RoleGuard],
        data: { rol: ['ROOT', 'ADMIN'] },
        loadChildren: () =>
          import('./pages/noticias/noticias.routes').then(
            (r) => r.NoticiasRoutes
          ),
      },
      {
        path: RoutesUrl.TORNEOS,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/torneos/torneos.routes').then(
            (r) => r.TorneosRoutes
          ),
      },
      {
        path: RoutesUrl.MISTAFF,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/staff/mi-staff/mi-staff.routes').then((r) => r.MiStaffRoutes),
      },
      {
        path: RoutesUrl.CRM,
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/crm/crm.routes').then((r) => r.CrmRoutes),
      },
      {
        path: RoutesUrl.CRMLI,
        // TODO: gating por crm-full-liga pendiente en backend
        canActivate: [authGuard],
        loadChildren: () =>
          import('./pages/crm-liga/crm-liga.routes').then((r) => r.CrmLigaRoutes),
      },
      /* MODULO TEMPORAL MAYO 2025
      {
        path: RoutesUrl.MAIN,
        loadChildren: () =>
          import('./pages/zarchived_main/main.routes').then((r) => r.MainRoutes),
        canActivate: [tokenGuard],
      },
      {
        path: RoutesUrl.CALENDAR,
        loadChildren: () => import('./pages/zarchived_match-calendar/match-calendar.routes').then(r => r.MatchCalendarRoutes),
        canActivate: [tokenGuard]
      },
      {
        path: RoutesUrl.POSITIONS_TABLE,
        loadChildren: () => import('./pages/zarchived_positions-table/positions-table.routes').then(r => r.PositionsTableRoutes)
      }*/


    ]
  },

  // --- REDIRECCIONES GLOBALES ---
  {
    // Si un usuario entra a la raíz del sitio ('/'), lo redirigimos a '/portal'.
    // Si requiere log... y está logueado, el authGuard lo dejará pasar. Si no, lo mandará a '/login'.
    path: '',
    redirectTo: 'portal',
    pathMatch: 'full',
  },
  {
    // Cualquier otra ruta que no coincida con las anteriores, redirige a '/main'.
    path: '**',
    redirectTo: 'main',
  },
];
